import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import fb from '../../../../assets/images/svg/ic_fb_12x12.svg';
import { connectPageFacebook } from '../../../../store/action/pageFacebookAction';
import { setPage } from '../../../../store/action/pageAction';
import { URL } from '../../../../routers/constants';
import { hideLoading, showLoading } from '../../../../store/action/loadingAction';
import Modal from '../../../shared/components/modal';

const Page = (props) => {
   const { data } = props;
   const [confirm, setConfirm] = useState(false);

   const dispatch = useDispatch();
   const navigate = useNavigate();

   const connectPage = () => {
      dispatch(showLoading());
      dispatch(connectPageFacebook(data, redirectHome, () => dispatch(hideLoading())));
   }

   const accessPage = () => {
      dispatch(showLoading());
      dispatch(setPage(data, redirectHome, () => dispatch(hideLoading())));
   }

   const redirectHome = () => {
      setTimeout(() => {
         navigate(URL.HOME);
         dispatch(hideLoading());
      }, 2000);
   }

   const handleConnect = () => {
      if (data.is_another_connected) {
         setConfirm(true);
      } else {
         connectPage();
      }
   }
   return (
      <div className="app-sh-connect-page--item">
         <div className="app-sh-connect-page--item-box">
            <div className="app-sh-connect-page--item-image">
               <span content={data.name} className="app-avatar app-avatar-circle app-avatar-image vt-avatar">
                  <img src={data.page_avatar ? data.page_avatar : fb} alt={data.name} />
               </span>
               <div className="ChannelIcon_channelIcon__j9xoE app-sh-connect-page--channel-icon">
                  <div className="ChannelIcon_iconWrapper__9JkCW ChannelIcon_icFb__vqtkJ">
                     <img className="" src={fb} alt="Facebook" /></div>
               </div>
            </div>
            <div className="app-sh-connect-page--item-content">
               <div className="app-sh-connect-page--item-content-top">
                  <div className="app-sh-connect-page--item-name">
                     {data.name}
                  </div>
               </div>
               {!!data.is_another_connected &&
                  <div className="app-sh-connect-page--item-connected-content">
                     <div className="app-sh-connect-page--item-connected-other-org">
                        <div className="app-sh-page--item-connected-other-org__desc">
                           Đang kết nối với shop khác
                        </div>
                     </div>
                  </div>
               }
               {!data.is_owned &&
                  <div className="app-sh-connect-page--item-role-fbpage">
                     <div className="app-sh-connect-page--item-role-fbpage__icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path fillRule="evenodd" clipRule="evenodd" d="M1.33337 8.00001C1.33337 4.32001 4.32004 1.33334 8.00004 1.33334C11.68 1.33334 14.6667 4.32001 14.6667 8.00001C14.6667 11.68 11.68 14.6667 8.00004 14.6667C4.32004 14.6667 1.33337 11.68 1.33337 8.00001ZM4.66671 8.66668H11.3334V7.33334H4.66671V8.66668Z" fill="#FC625D"></path>
                        </svg>
                     </div>
                     <div className="app-sh-connect-page--item-role-fbpage__desc">
                        Bạn không đủ quyền quản lý trang Facebook này nên không thể thực hiện kết nối trang.
                     </div>
                  </div>
               }
            </div>
            <div className="app-sh-connect-page--item-btn-connect">
               {!data.is_connected ?
                  <React.Fragment>
                     {!!data.is_owned &&
                        <button type="button" className="app-btn app-btn-primary" onClick={handleConnect}>
                           <span>Kết nối</span>
                        </button>
                     }
                  </React.Fragment>
                  :
                  <button type="button" className="app-btn app-btn-default app-sh-connect-page--item-btn-connected" onClick={accessPage}>
                     <span>Truy cập</span>
                  </button>
               }
            </div>
         </div>
         {confirm &&
            <Modal>
               <div className="modal-dialog app-modal modal-sm" role="document">
                  <div className="modal-content" >
                     <div className="app-modal-header">
                        <h4 className="app-modal-title">Thông báo</h4>
                        <span className="app-close" onClick={() => setConfirm(false)}>
                           <svg className="app-svg-inline-block" width="20px" height="20px" viewBox="0 0 24 24">
                              <g>
                                 <path
                                    d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z">
                                 </path>
                              </g>
                           </svg>
                        </span>
                     </div>
                     <div className="app-modal-body">
                        <div className="app-sh-modal-confirm-page-change-org--container">
                           <div className="app-sh-modal-confirm-page-change-org--text app-modal-confirm-page-change-org--text-bold">
                              Facebook Page này hiện đã được dùng để kết nối đến shop khác.
                           </div>
                           <div className="app-sh-modal-confirm-page-change-org--text">
                              Bạn có chắc chắn muốn tiếp tục sử dụng Facebook Page <b>Khăn mặt</b> để tạo kết nối mới?</div>
                           <div className="app-sh-modal-confirm-page-change-org--text">
                              <span className="app-sh-modal-confirm-page-change-org--text-bold">Lưu ý: </span>
                              <span className="">
                                 Hành động này sẽ làm hủy kết nối với shop cũ và mất các thông tin mà bạn đã thiết lập trên Viettelsocial đối với Facebook Page này.
                              </span>
                           </div>
                        </div>
                     </div>
                     <div className="app-modal-footer">
                        <div className="col-auto">
                           <div className="">
                              <button type="button" className="app-btn app-btn-default" onClick={() => setConfirm(false)}>Hủy</button>
                              <button type="button" className="app-btn app-btn-primary" onClick={connectPage}>Xác nhận</button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </Modal>
         }
      </div>
   )
}

export default Page;